module.exports = __webpack_public_path__ + "img/img-4.c3285fe9.png";